export const timeZoneData = (id, session) => {
    return {
        // jwt_token: Cookies.get('jwt_token'),
        jwt_token: localStorage.getItem('jwt_token_user'),
        timezone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone,
        project_id_jwt: id,
        session
    }
};